<template>
    <div>
        <v-container fluid>
            <v-row>
                <v-col>
                    <h2 v-text="this.editing ? this.titulo : 'Nueva'"></h2>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col>
                    <v-text-field v-model="currentProveedor.nombre" :rules="[(v) => !!v || 'Nombre es necesario']"
                        label="Nombre" required>
                    </v-text-field>
                </v-col>
                <v-col>
                    <v-text-field v-model="currentProveedor.referencia" label="Referencia" required>
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row align="center">
                <v-col align="center">
                    <v-btn v-if="this.editing" color="error" class="mr-2" @click="deleteProveedor">
                        Borrar
                    </v-btn>

                    <v-btn v-if="this.editing" color="success" @click="updateProveedor">
                        Actualizar
                    </v-btn>

                    <v-btn v-if="!this.editing" color="success" @click="saveProveedor">
                        Guardar
                    </v-btn>
                </v-col>
            </v-row>

            <v-row v-if="this.editing">
                <v-col>
                    <template>
                        <v-data-table v-if="currentProveedor.proveedor_base" :headers="tabla_bases"
                            :items="currentProveedor.proveedor_base" class="elevation-1" :items-per-page="-1"
                            hide-default-footer>

                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Bases de {{titulo}}</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>

                            <template v-slot:item.cod_base.cod_base="{ item }">
                                <router-link :to="'/bases/' + item.cod_base.cod_base">
                                    {{item.cod_base.cod_base }}
                                </router-link>
                            </template>

                        </v-data-table>
                    </template>
                </v-col>
                <v-col>
                    <template>
                        <v-data-table v-if="currentProveedor.proveedor_aditivo" :headers="tabla_aditivos"
                            :items="currentProveedor.proveedor_aditivo" class="elevation-1" :items-per-page="-1"
                            hide-default-footer>

                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Aditivos de {{titulo}}</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>

                            <template v-slot:item.cod_aditivo.cod_aditivo="{ item }">
                                <router-link :to="'/aditivos/' + item.cod_aditivo.cod_aditivo">
                                    {{item.cod_aditivo.cod_aditivo }}
                                </router-link>
                            </template>

                        </v-data-table>
                    </template>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import { mapMutations } from "vuex";
import ProveedoresDataService from "@/services/ProveedoresDataService";

export default {
    name: "ProveedorId",
    props: ['id'],
    data() {
        return {
            editing: false,
            titulo: "",
            currentProveedor: {
                cod_proveedor: 0,
                nombre: "",
                referencia: "",
            },
            tabla_aditivos: [
                { text: "Codigo", value: "cod_aditivo.cod_aditivo" },
                { text: "Descripción", value: "cod_aditivo.descripcion" },
                { text: "Precio", value: "precio" },
            ],
            tabla_bases: [
                { text: "Codigo", value: "cod_base.cod_base" },
                { text: "Descripción", value: "cod_base.descripcion" },
                { text: "Precio", value: "precio" },
            ],
        };
    },
    methods: {
        ...mapMutations("snackbar", ["setSnack"]),
        getProveedor(id) {
            ProveedoresDataService.get(id)
                .then((response) => {
                    this.currentProveedor = response.data;
                    this.titulo = this.currentProveedor.nombre;
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        updateProveedor() {
            ProveedoresDataService.update(this.currentProveedor.cod_proveedor, this.currentProveedor)
                .then((response) => {
                    this.setSnack({ message: "Actualizado correctamente", color: "success" });
                    this.$router.push({ name: "ProveedoresList" });
                })
                .catch((e) => {
                    if (e.response.data.detail) {
                        this.setSnack({ message: e.response.data.detail, color: "error" });
                    } else {
                        this.setSnack({ message: e.message, color: "error" });
                    }
                    console.log(e);
                });
        },
        deleteProveedor() {
            ProveedoresDataService.delete(this.currentProveedor.cod_proveedor)
                .then((response) => {
                    this.setSnack({ message: "Borrado correctamente", color: "success" });
                    this.$router.push({ name: "ProveedoresList" });
                })
                .catch((e) => {
                    console.log(e);
                    this.setSnack({ message: e.response.data.detail, color: "error" });
                });
        },
        saveProveedor() {
            let data = {
                nombre: this.currentProveedor.nombre,
                referencia: this.currentProveedor.referencia,
            };
            ProveedoresDataService.create(data)
                .then((response) => {
                    this.setSnack({ message: "Creado correctamente", color: "success" });
                    this.$router.push({ name: "ProveedoresList" });
                })
                .catch((e) => {
                    if (e.response.data.detail) {
                        this.setSnack({ message: e.response.data.detail, color: "error" });
                    } else {
                        this.setSnack({ message: e.message, color: "error" });
                    }
                    console.log(e);
                });
        },
    },
    mounted() {
        this.editing = false;
        if (this.$route.params.id) {
            this.getProveedor(this.$route.params.id);
            this.editing = true;
        }
    },
    watch: {
        '$route.params.id'(newId, oldId) {
            this.editing = false;
            this.currentProveedor = {
                cod_proveedor: 0,
                nombre: "",
                referencia: "",
            };
        }
    }
};
</script>